import * as React from 'react';
import { FormControlLabel, Checkbox } from '@material-ui/core';

export class CheckBox extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {checked: this.props.checked};

        this.handlechanged = this.handlechanged.bind(this);
    }

    private handlechanged(event: React.ChangeEvent<HTMLInputElement>) {
        var newValue = event.target.checked;
        this.setState({checked: newValue});
        if (this.props.onChange != null) {
            this.props.onChange(newValue);
        }
    }

    public render() {
        return (
            <FormControlLabel
              control={
                <Checkbox checked={this.state.checked} onChange={this.handlechanged} />
              }
              label={this.props.label}
            />
        )
    }

}

export interface Props {
    checked?: boolean;
    label: string;
    onChange?: {(newValue: boolean): void};
}

interface State {
    checked: boolean;
}